"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var next_intl_1 = require("next-intl");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TournamentInGame_1 = __importDefault(require("./TournamentInGame"));
var TournamentsInGame = function () {
    var t = (0, next_intl_1.useTranslations)();
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.wrapper, " ").concat(styles_module_scss_1.default.tournamentsWrapper) },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.tabTitle },
            react_1.default.createElement("img", { src: "/img/icons/tournaments.svg", alt: "top winners icon" }),
            t('translation.tournaments')),
        react_1.default.createElement(TournamentInGame_1.default, null)));
};
exports.default = TournamentsInGame;
